import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import TipoIngreso from './TipoIngreso';





interface TipoIngresoTableProps {
  data: TipoIngreso[];
  columns: TableColumn<TipoIngreso>[];
  customStyles: Record<string, any>;
}

const TipoActivoTable: React.FC<TipoIngresoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<TipoIngreso>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default TipoActivoTable;